import { StarFilled } from '@ant-design/icons';
import { DeviceMobileIcon } from '@heroicons/react/outline';
import { appstoreLogo } from 'assets';
import PlayStoreIcon from 'assets/Icons/PlayStoreIcon';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import React from 'react';

import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';

const Application = () => {
  const route = useRouter();
  return (
    <div className='w-full h-full bg-dropDownMenuBg rounded-3xl p-6 flex-col flex gap-6 justify-between'>
      <div className='flex flex-col justify-center mt-5 gap-3 items-center '>
        <div className=' bg-white/10 rounded-lg h-10 w-10 flex items-center justify-center '>
          <DeviceMobileIcon className='text-white w-6 h-6 ' />
        </div>
        <p className='text-lg leading-[26px] font-semibold text-white text-center'>
          Check Out Our Application
        </p>
        <p className='text-sm font-normal leading-[22px] text-grayZl-600 text-center'>
          Users say ZebraLearn helped them feel more focused, in control, and
          mentally sharper.
        </p>
      </div>
      <div className='relative bg-black rounded-xl flex flex-col'>
        <div className='absolute top-0 left-0 w-full h-full flex items-center justify-center'>
          <ButtonDefault
            onClick={() => route.push('/get-our-app')}
            size={0}
            variant={ButtonVariants.PRIMARY}
            className='px-4 py-2.5 rounded-full border-[2px] border-grayZl-900 text-base text-white font-medium bg-black'
            roundedFull
          >
            Download Our Application
          </ButtonDefault>
        </div>
        <div className='flex items-center gap-4 p-[54px]'>
          <Image
            alt='appstore logo'
            width={64}
            height={64}
            src={appstoreLogo}
          />
          <div className='flex flex-col gap-1'>
            <p className='text-white text-sm leading-[22px] font-normal'>
              App Store Rating
            </p>
            <div className='flex gap-1 items-center'>
              <p className='text-2xl text-white font-semibold'>4.4</p>
              <StarFilled className='w-6 h-6 text-[#FFFB12]' />
            </div>
          </div>
        </div>
        <div className='h-0.5 bg-grayZl-900 w-full' />
        <div className='flex items-center gap-4 p-[54px]'>
          <PlayStoreIcon className='w-16 h-16' />
          <div className='flex flex-col gap-1'>
            <p className='text-white text-sm leading-[22px] font-normal'>
              Play Store Rating
            </p>
            <div className='flex gap-1 items-center'>
              <p className='text-2xl text-white font-semibold'>4.6</p>
              <StarFilled className='w-6 h-6 text-[#FFFB12]' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Application;
